var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 26,
    viewBox: "0 0 26 26",
    width: 26,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fill: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.26282 21.2956c0-.2493.20209-.4514.45139-.4514h20.76389c.2493 0 .4514.2021.4514.4514s-.2021.4514-.4514.4514h-20.76389c-.2493 0-.45139-.2021-.45139-.4514z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.4226 11.8165c.2493 0 .45139.2021.45139.4514v9.0277c0 .2493-.20209.4514-.45139.4514-.24929 0-.45139-.2021-.45139-.4514v-9.0277c0-.2493.2021-.4514.45139-.4514z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.7697 11.8165c.2493 0 .4514.2021.4514.4514v9.0277c0 .2493-.2021.4514-.4514.4514s-.4514-.2021-.4514-.4514v-9.0277c0-.2493.2021-.4514.4514-.4514z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.5626 4.42973c.1553-.11466.3432-.17653.5362-.17653.1931 0 .381.06187.5363.17653l9.0142 6.66267c.1516.1137.2636.2722.3201.4531.0565.1808.0546.3749-.0053.5546-.0599.1798-.1749.3361-.3286.4469s-.3384.1704-.5279.1704h-18.0212c-.18948 0-.37416-.0596-.52787-.1704s-.26867-.2671-.32858-.4469c-.05992-.1797-.06176-.3738-.00527-.5546.0565-.1809.16847-.3394.32005-.4531l.00259-.0019zm.5362.72625-9.0124 6.65872h18.0212z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.8745 5.76143c.1693-.1693.3989-.26442.6384-.26442h1.8055c.2394 0 .4691.09512.6384.26442.1693.16931.2644.39893.2644.63836v3.87381c0 .2493-.2021.4514-.4514.4514s-.4514-.2021-.4514-.4514v-3.87381h-1.8055v1.87597c0 .2493-.2021.45139-.4514.45139s-.4514-.20209-.4514-.45139v-1.87597c0-.23943.0951-.46905.2644-.63836z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.94389 14.7892c.16931-.1693.39893-.2644.63836-.2644h2.70835c.2394 0 .469.0951.6383.2644.1694.1693.2645.399.2645.6384v4.0625c0 .2493-.2021.4514-.4514.4514s-.4514-.2021-.4514-.4514v-4.0625h-2.70835v4.0625c0 .2493-.20209.4514-.45138.4514-.2493 0-.45139-.2021-.45139-.4514v-4.0625c0-.2395.09511-.4691.26441-.6384z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.9988 15.4276c0-.4986.4042-.9028.9028-.9028h3.6111c.4986 0 .9028.4042.9028.9028v2.7083c0 .4986-.4042.9028-.9028.9028h-3.6111c-.4986 0-.9028-.4042-.9028-.9028zm4.5139 0h-3.6111v2.7083h3.6111z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.67954 19.9415v1.3541c0 .2493-.20209.4514-.45138.4514-.2493 0-.45139-.2021-.45139-.4514v-1.3541c0-.2395.09511-.4691.26441-.6384s.39893-.2644.63836-.2644h4.51386c.2395 0 .4691.0951.6384.2644s.2644.3989.2644.6384v1.3541c0 .2493-.2021.4514-.4514.4514s-.4514-.2021-.4514-.4514v-1.3541z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.60ae82ad4682f202d284565800954f9b.svg";
export { ForwardRef as ReactComponent };